module.exports = __webpack_public_path__ + "static/media/psicosomatica.a54d9e47.svg";